<template>
  <div>
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            
            <div class="col-md-3">
              <label for="date">Disbursement Date From</label>
              <input type="date" v-model="form.disbursementStartDate" name="disbursementStartDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3">
              <label for="date">Disbursement Date To</label>
              <input type="date" v-model="form.disbursementEndDate" name="disbursementEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment End Date">
            </div>
            <div class="col-md-3">
              <label for="date">EMI End Date From</label>
              <input type="date" v-model="form.startEmiEndDate" name="startEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3">
              <label for="date">EMI End Date To</label>
              <input type="date" v-model="form.endtEmiEndDate" name="endEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseCollectionCenter(branch, withChangeFilter = true)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="canAccess('collection-center-create')">
              <label for="Branch">Group</label>
              <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="colCenters" placeholder="Select Group" v-on:input="getRecordByCollectionCenter(collectionCenter)" required></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-3">
              <button class="btn btn-info" @click="printViewDisbursementByCollectionCenter(status = 'disbursed')">Get Print</button>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Group Disbursement List</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('member-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th class="hidden-xs">Pl Name</th>
                <th class="hidden-xs">Pl Emi Type</th>
                <th>Plan Amt</th>
                <th class="hidden-xs">Dis Dt</th>
                <th class="hidden-xs">Emi Start Dt </th>
                <th class="hidden-xs">Emi End Dt </th>
                <th>Group</th>
                <th>Member</th>
                <th class="hidden-xs">Staff</th>
                <th class="hidden-xs">Pay Mode</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td class="hidden-xs">{{ planName(row.plan) }}</td>
                <td class="hidden-xs">{{ planRecoveryType(row.plan) }}</td>
                <td>{{ planAmt(row) }}</td>
                <td class="hidden-xs">{{ row.disbursementDate | myDate }}</td>
                <td class="hidden-xs">{{ row.emiStartDate | myDate }}</td>
                <td class="hidden-xs">{{ row.emiEndDate | myDate }}</td>
                <td>{{ row.collection_center.name }}</td>
                <td><i v-if="row.member">{{ row.member.name }}</i></td>
                <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td>
                <td class="hidden-xs">
                  {{row.branch_ledger.ledger.name}}
                </td>
                <td>
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                      Task <span class="caret"></span>
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPreviousLoanRecords(row)" title="Previous Loan">
                          <i class="fa fa-leanpub"></i> Previous Loan
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-update')">
                        <a v-show="row.status == 'pending'" @click="editModal(row)">
                          <i class="fa fa-pencil"></i> Update
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-delete')">
                        <a v-show="row.status == 'disbursed' || row.status == 'pending'" @click="deleteDisbursment(row.id)">
                          <i class="fa fa-trash"></i> Delete
                        </a>
                      </li>
                      <li v-show="row.filechargeStatus == 'exclude'">
                        <a @click="fileChargeModal(row)" title="File Charge">
                          <i class="fa fa-file"></i> File Charge
                        </a>
                      </li>
                      <li v-show="row.processingFeeStatus == 'exclude'">
                        <a @click="processingFeeModal(row)" title="Processing Fee">
                          <i class="fa fa-hourglass"></i> Processing Fee
                        </a>
                      </li>
                      <li v-show="row.insuranceFeeStatus == 'exclude'">
                        <a @click="insuranceFeeModal(row)" title="Insurance Fee">
                          <i class="fa fa-user-md"></i> Insurance Fee
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPrintModal(row)" title="For Staff">
                          <i class="fa fa-print"></i> Loan Agreement
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a title="For Customer" @click="viewPrintCustomerModal(row)">
                          <i class="fa fa-hand-o-up"></i> Loan Sanction Letter
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a title="Loan EMI Card" @click="viewPrintCustomerEMIModal(row)">
                          <i class="fa fa-book"></i> Loan EMI Card
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a title="Demand Promissory Note" @click="viewPrintDimandProbeshnoryNote(row)">
                          <i class="fa fa-sticky-note-o"></i> Demand Promissory Note
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a title="Aadhar Agreement Letter" @click="viewPrintAadharAgreementLetter(row)">
                          <i class="fa fa-handshake-o"></i> Aadhar Agreement Letter
                        </a>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="btn-group">
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      v-show="row.status == 'disbursed' || row.status == 'pending'"
                      @click="deleteDisbursment(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-show="row.filechargeStatus == 'exclude'"
                      @click="fileChargeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="File Charge"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-show="row.processingFeeStatus == 'exclude'"
                      @click="processingFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Processing Fee"
                    >
                      <i class="fa fa-hourglass"></i>
                    </button>
                    <button
                      v-show="row.insuranceFeeStatus == 'exclude'"
                      @click="insuranceFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Insurance Fee"
                    >
                      <i class="fa fa-user-md"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      
                      @click="viewPrintModal(row)"
                      title="For Staff"
                      class="btn btn-primary btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="For Customer"
                      @click="viewPrintCustomerModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-hand-o-up"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Loan EMI Card"
                      @click="viewPrintCustomerEMIModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-book"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Dimand ProbeshnaryNote"
                      @click="viewPrintDimandProbeshnoryNote(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-sticky-note-o"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Aadhar Agreement Letter"
                      @click="viewPrintAadharAgreementLetter(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-handshake-o"></i>
                    </button>
                  </div> -->
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.file-charge-modal -->
      <div class="modal fade" id="fileChargeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">File Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect File Charge </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.processing-fee-modal -->
      <div class="modal fade" id="processingFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Processing Fee Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Processing Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.insurance-fee-modal -->
      <div class="modal fade" id="insuranceFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Insurance Fee Charge</h4>
            </div>
            <form @submit.prevent.once="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Insurance Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            
            <div class="modal-body" id="print">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <!-- <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> -->
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-center" style="text-align:center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" style="text-align:center" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h2 class="text-center" style="text-align:center;">Loan Agreement</h2>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed" style="border-width:1px; width:100%;">
                        <thead style="border-width:1px">
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody style="border-width:1px">
                          <tr>
                            <td>Customer Name </td>
                            <td> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td>Group Name : {{seeRecord.collection_center.name}}</td>
                            <td rowspan="3">
                              <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br>Customer Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr>
                            <td>Contact No </td><td> {{seeRecord.member.mobile}}</td>
                            <td>Gender : {{mem.gender}}</td>
                          </tr>
                          <tr>
                            <td>DOB </td><td> {{mem.dob | myDate}}</td>
                            <td>Spouse Name  : {{mem.spouseName}}</td>
                          </tr>
                          <!-- <tr>
                            <td>Father Name (C/O) </td><td> {{mem.fatherName}}</td>
                          </tr> -->
                          <tr>
                            <td colspan="4"><strong>Address Details</strong></td>
                            <!-- <td colspan="2"></td> -->
                          </tr>
                          <tr>
                              <td><strong>Address </strong></td><td> {{mem.address}}, {{mem.area}}</td>
                              <td><strong>District/State/Pincode </strong></td><td v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                            </tr>
                            <tr>
                              <td colspan="2"><strong>Bank Details</strong></td>
                              <td colspan="2"><strong>Applied Loan Details</strong></td>
                            </tr>
                            <tr>
                              <td><strong>Bank : </strong> <span v-if="mem.bank"> {{mem.bank.name}}</span> </td>
                              <td><strong>Branch : </strong><span v-if="mem.bankBranch"> {{mem.bankBranch}}</span></td>
                              <td><strong>Loan ID :</strong> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span> </td>
                              <td><strong>Plan Name :</strong> {{pl.name}}</td>
                            </tr>
                            <tr>
                              <td><strong>Account Holder : </strong>{{mem.accountHolderName}}</td>
                              <td><strong>Account Number : </strong> <span v-if="mem.accountNumber">{{mem.accountNumber}}</span></td>
                              <!-- <td><strong>Interest Rate (%) :</strong> 22.7 </td> -->
                              <td><strong v-if="pl.rateOfInterest > 0">Interest Rate (%) : {{pl.rateOfInterest}} </strong></td>
                              <td> <strong>GST Include : </strong>{{pl.includeGst}}</td>
                              <!-- <td>Insurance Charge </td><td v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td v-else> {{pl.fileCharge}}</td> -->
                            </tr>
                            <tr>
                              <td><strong>IFSC : </strong>{{mem.ifsc}}</td>
                              <td></td>
                              <td><strong>Loan Amount :</strong> {{ planAmt(seeRecord) }}</td>
                              <td><strong>File Charge : </strong>{{ fileChargeFee(seeRecord) }}</td>
                            </tr>
                            <tr>
                              <td colspan="2"><strong>Income Details</strong></td>
                              <td><strong>Processing Fee :</strong> {{ processingFee(seeRecord) }}</td>
                              <td><strong>Insurance Fee :</strong> {{ insuranceFee(seeRecord) }}</td>
                            </tr>
                            <tr v-if="pl.rateOfInterest">
                              <td><strong>Income (INR) : </strong>{{mem.incomeAmount}}</td>
                              <td><strong>Occupation : </strong>{{mem.jobType}}</td>
                              <td><strong>Recovery type :</strong> {{pl.recoveryType}}</td>
                              <td><strong>Amount to be Paid :</strong> <span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                              
                            </tr>
                            <tr>
                              <td><strong>Business Name : </strong>{{mem.businessName}}</td>
                              <td><strong>Income Type : </strong>{{mem.incomeType}}</td>
                              <td><strong>No of Payments : </strong> <span v-if="pl.noOfPayments">{{pl.noOfPayments}}</span></td>
                              <td> </td>
                            </tr>
                            <tr>
                              <td><strong>Minimum Income : </strong>{{mem.minAmount}}</td>
                              <td> </td>
                              <td><strong>Purpose : </strong><span v-if="seeRecord.purpose">{{seeRecord.purpose.purpose}}</span></td>
                              <td><strong>Description : </strong>{{seeRecord.description}}</td>
                            </tr>
                          <!-- </tbody>
                        </table>

                        <table class="table table-condensed">
                          <tbody style="border-width:3px"> -->
                            <tr>
                              <td colspan="3"><strong>Guarantor Details : </strong></td>
                              <td rowspan="3">
                                <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Name : </strong> </td><td> <span v-if="seeRecord.guarantor">{{seeRecord.guarantor.name}} ( {{seeRecord.guarantor.code}} )</span></td>
                              <td><strong>Contact Number : </strong><span v-if="seeRecord.guarantor">{{seeRecord.guarantor.mobile}} </span></td>
                            </tr>
                            <tr>
                              <td><strong>Nominee Name : {{mem.nomineeName}}</strong></td>
                              <td><strong>Nominee Mobile : </strong>{{mem.nomineePhone}}</td>
                              <td><strong>Nominee Dob : </strong>{{mem.nomineeDob}}</td>
                            </tr>
                        </tbody>
                      </table>
                      <br><br><br><br><br><br><br>
                      <table class="table" style="border-width:1px;width:100%;font-size:12px; bottom:20px;">
                        <thead>
                          <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                          <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                          <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                        </thead>
                      </table>
                      <p style="page-break-before: always;"></p>
                      <h3>Repayment Schedule Terms </h3>
                      
                      <table class="table table-condensed" style="border-width:1px; width:100%;">
                        <thead>
                          <tr>
                            <td><strong>Sr. No</strong></td>
                            <td><strong>EMI Date</strong></td>
                            <td><strong>Interest</strong></td>
                            <td><strong>Principal</strong></td>
                            <td><strong>Amount</strong></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(memberEmiRecord) in memberEmiRecords" :key="memberEmiRecord.id">
                            <td>{{memberEmiRecord.emiNo}}</td>
                            <td>{{memberEmiRecord.emiDate}}</td>
                            <td>{{memberEmiRecord.intrest}}</td>
                            <td>{{memberEmiRecord.principal}}</td>
                            <td>{{memberEmiRecord.total}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <br><br><br><br><br><br>
                      <table class="table" style="border-width:1px;width:100%;font-size:12px; bottom:20px;">
                        <thead>
                          <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                          <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                          <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                        </thead>
                      </table>
                      <div v-if="myhost === 'progati.micromuneem.com'">
                        <p style="page-break-before: always;"></p>
                        <p><strong>ঋণ নিম্নলিখিত নিয়ম সাপেক্ষে: -</strong></p>
                        <p>1. কোম্পানির অপারেটিভ অ্যাকাউন্ট ধারণকারী অন্যান্য সদস্যদের সুদের সাথে ঋণ দেওয়া হয়।</p>
                        <p>2. সমস্ত ঋণ মাসিক/সাপ্তাহিক/দৈনিক কিস্তিতে ঋণগ্রহীতার আয়/ পরিশোধের ক্ষমতার উপর নির্ভর করে কিন্তু কোম্পানি কর্তৃক প্রদত্ত সর্বোচ্চ সময়ের মধ্যে পরিশোধযোগ্য।</p>
                        <p>3. একজন আবেদনকারীকে সময়ে সময়ে কোম্পানির দ্বারা নির্ধারিত শেয়ারের ধারক হতে হবে।</p>
                        <p>4. জামিনকে অবশ্যই সক্রিয় অ্যাকাউন্টের সাথে কোম্পানির সদস্য হতে হবে। ব্যক্তিগত জামিন/এসএইচজি স্কিম/যৌথ দায় পরিকল্পনার বিপরীতে ঋণের জন্য দুই বা তার বেশি জামিনের প্রয়োজন হবে। একজন ব্যক্তি একবারে একাধিক ঋণের জন্য জামিন থাকতে পারে না। তদুপরি, ইতিমধ্যে কোম্পানির ঋণে থাকা সদস্যরা জামিন/গ্যারান্টি থাকতে পারে না।</p>
                        <p>5. ঋণ মঞ্জুর করা হবে শুধুমাত্র যদি কোম্পানী আবেদনকারীর দ্বারা প্রদত্ত তথ্য এবং সেইসঙ্গে আবেদনকারীর অতীত রেকর্ড এবং জামিনের বিষয়ে সন্তুষ্ট হয়।</p>
                        <p>6. কোম্পানী ঋণের আবেদন প্রত্যাখ্যান করার জন্য বা বর্ধিত জামিন বা জামিন বাতিল করার কারণ জানাতে বাধ্য থাকবে না।</p>
                        <p>7. কোম্পানির ঋণ অনুমোদনকারী কমিটি কর্তৃক একটি ঋণ মঞ্জুর করা সত্ত্বেও I সেক্রেটারি বা মহাব্যবস্থাপক অগ্রিম আটকে রাখার কারণে। কোম্পানি তার বিবেচনার ভিত্তিতে অনুমোদন প্রত্যাহার করার অধিকার সংরক্ষণ করে এবং প্রয়োজন হবে না, বা এর জন্য কোনো কারণ বরাদ্দ করার আহ্বান জানানো হবে না।</p>
                        <p>8. মাসিক সাত দিন বিলম্ব, সাপ্তাহিক এক সপ্তাহ বিলম্ব, দৈনিক কিস্তিতে একদিন বিলম্ব ঋণকে ওভারডিউ লোনে রূপান্তরিত করবে এবং একটি নোটিশ করতে পারে যার জন্য Rs. প্রতিটি নোটিশের জন্য ঋণগ্রহীতার কাছ থেকে 100/- চার্জ করা হবে।</p>
                        <p>9. কোম্পানির মতে, যে উদ্দেশ্যে এটি নেওয়া হয়েছিল তার জন্য এটি প্রয়োগ করা না হলে ঋণ অবিলম্বে ফেরত নেওয়া হবে৷ এই বিষয়ে কোম্পানির সিদ্ধান্ত চূড়ান্ত এবং চূড়ান্ত এবং ঋণগ্রহীতা বা জামিনদারদের দ্বারা প্রশ্নে বলা দায়বদ্ধ নয়।</p>
                        <p>10. কোনো ঋণগ্রহীতার দুই মাসের জন্য ক্রমাগত খেলাপি হলে, কোম্পানি ঋণগ্রহীতা বা জামিনদারদের নিয়োগকর্তাদের কাছে যাওয়ার অধিকার সংরক্ষণ করে এবং/অথবা তাদের সদস্যদের তথ্যের জন্য তাদের নাম প্রকাশ করে। অধিকন্তু এটি আইনী পদ্ধতিতে ঋণ পুনরুদ্ধারের জন্য উপযুক্ত কর্তৃপক্ষের কাছেও যেতে পারে।</p>
                        <p>11. যদি কোন কারণে ঋণগ্রহীতা নির্ধারিত তারিখে সম্মত কিস্তি পরিশোধ করতে না পারেন তবে তাকে যতটা সম্ভব পরিশোধ করতে হবে (যদিও তা ছোটই হতে পারে) এবং কিস্তি হ্রাস বা সময় বাড়ানোর জন্য লিখিতভাবে আবেদন করতে হবে। তার/তার জামিনের লিখিত সম্মতির মধ্যে সেখানে তার/তার পরিস্থিতির বিশদ বিবরণ দেয় যে কেন সে সম্মত মাসিক কিস্তি, সাপ্তাহিক কিস্তি, দৈনিক কিস্তি পরিশোধ করতে অক্ষম।</p>
                        <p>12. কোম্পানী কোন সূচনা দিতে বাধ্য নয় এবং কোন সূচনা বা নোটিশ না প্রাপ্তি ঋণগ্রহীতার দ্বারা কিস্তি পরিশোধের ক্ষেত্রে জামানত ফর্ম দ্বারা একটি অজুহাত হিসাবে অঙ্গীকার করা যাবে না। ঋণগ্রহীতা নির্ধারিত তারিখে সম্মত মাসিক কিস্তি, সাপ্তাহিক কিস্তি, দৈনিক কিস্তি পরিশোধ করে তা দেখা জামিনের কর্তব্য; এবং ঋণ গ্রহীতা কর্তৃক ডিফল্ট বা কিস্তি পরিশোধে ঋণগ্রহীতার অক্ষমতা বা ব্যর্থতার ক্ষেত্রে, জামিনকে অবশ্যই পরবর্তী মাসের নির্ধারিত তারিখের আগে তা পরিশোধ করতে হবে। একজন সদস্যের অন্যের কাছে জামিন হওয়া উচিত, শুধুমাত্র যদি সে চিনতে পারে এবং তার জামিনের দায়িত্ব পালন করতে পারে। এটি স্পষ্টভাবে বোঝা উচিত যে প্রতিটি জামিন ঋণের সম্পূর্ণ পরিমাণের জন্য দায়ী (পরিষেবা এবং অন্যান্য চার্জ সহ) এবং অনুপাতে নয়।</p>
                        <p>13. ঋণগ্রহীতা এবং জামিনদাররা একজন কর্মকর্তার সামনে কোম্পানিতে ব্যক্তিগতভাবে নিজেদের উপস্থাপনের মাধ্যমে ঋণ বন্ড এবং সংশ্লিষ্ট অন্যান্য নথিপত্র সম্পাদন করবে।</p>
                        <p>14. কোম্পানির প্রশাসনিক ও চলমান ব্যয় পুনরুদ্ধারের জন্য সময়ে সময়ে ব্যবস্থাপনা কমিটি কর্তৃক নির্ধারিত ঋণের উপর কোম্পানি একটি সার্ভিস চার্জ ধার্য করবে।</p>
                        <p>15. ঋণগ্রহীতা এবং জামিনদাররা তাদের ঠিকানা বা যোগাযোগ নম্বরে কোনো পরিবর্তনের ক্ষেত্রে তিন দিনের মধ্যে অফিসকে জানাতে বাধ্য।</p>
                        <p>16. উপরের সমস্ত পক্ষগুলি নিম্নলিখিত সমস্ত শর্তাবলীতে সম্মত যে ঋণগ্রহীতা ক্ষুদ্রঋণের নিয়ম অনুযায়ী এই পরিমাণ ব্যবহার করবেন এবং এই পরিমাণ বা এর কোনো অংশ অন্য কোনো উদ্দেশ্যে ব্যবহার করবেন না। আমরা এও সম্মতি দিচ্ছি যে যদি কোম্পানি ব্যাখ্যা করার কোনো কারণ খুঁজে পায় যা মেনে করা হয়নি, তাহলে কোম্পানির এই ঋণের পরিমাণ বা এর কিছু অংশ প্রত্যাহার করার অধিকার আছে কোনো ছাড় ছাড়াই।</p>
                        <p>17. আমি এবং আমার জামিনদার অতীতে কোন অবৈধ কাজের সাথে জড়িত নই এবং আমাদের বিরুদ্ধে কোন আদালতে কোন ফৌজদারি মামলা বিচারাধীন নেই বা কোন থানায় কোন এফআইআর নথিভুক্ত করা হয়নি।</p>
                        <p>18. আমি/আমাদের উপর কোন আর্থিক প্রতিষ্ঠান, ব্যাঙ্ক ফাইন্যান্স কোম্পানী থেকে কোন প্রকার ঋণের বোঝা নেই, বা কোন আর্থিক প্রতিষ্ঠান, ব্যাঙ্ক বা ফাইন্যান্স কোম্পানী থেকে আমাকে/আমাদের খেলাপি হিসাবে ঘোষণা করা হয়নি।</p>
                        <p>19. আমি/আমরা উল্লিখিত ঋণের সম্পূর্ণ কিস্তি পরিশোধ করতে সম্পূর্ণরূপে সক্ষম এবং আমি/আমরা কোনো অবস্থাতেই অর্থপ্রদানে বিলম্ব করব না</p>
                        <p>20. কোম্পানীর যে কোন কর্মচারী কিস্তির টাকা আদায় করতে আসবেন, আমি তাদের সাথে ভদ্র আচরন রাখব এবং তাকে কোন প্রকার আপত্তিকর কথা বলবো না, কোন প্রকার ক্ষতি বা মারধর করার চেষ্টা করব না এবং নোংরামি করব না। তার বিরুদ্ধে. আচরণ বা গালিগালাজের অভিযোগ করবে না যদি আমাদের দ্বারা কোনো আপত্তিজনক আচরণ করা হয় তাহলে কোম্পানি আমাদের বিরুদ্ধে আইনি ব্যবস্থা নিতে স্বাধীন থাকবে।</p>
                        <p>21. আমি/আমরা নোটিশ, অনুস্মারক এবং ইলেকট্রনিক তথ্য ফোন ইত্যাদি দেওয়ার জন্য কোম্পানি দায়ী থাকব না। ঋণ পরিশোধের নির্ধারিত তারিখের সূচনা সংক্রান্ত আমার কিস্তির সম্পূর্ণ অর্থ প্রদানের জন্য, এর সাথে সম্পর্কিত সম্পূর্ণ দায়িত্ব আমার/আমাদের. </p>
                        <p>22. যদি ঋণগ্রহীতা (গণ) বা গ্যারান্টার (রা) তাদের ব্যবসা, চাকরি, বাসস্থান, মোবাইল নম্বর বা ইমেল আইডি পরিবর্তন করেন, তাহলে তারা কোম্পানিকে পূর্বে লিখিত নোটিশ দেবেন।</p>
                        <p>23. যে আমি/আমরা একটি বিবৃতি দেওয়ার প্রতিশ্রুতি দিচ্ছি যে যদি ভবিষ্যতে আমাদের দ্বারা কিস্তিগুলি ভবিষ্যতে চেকের মাধ্যমে পরিশোধ করা হয়, তাহলে আমরা ব্যাঙ্কে দেওয়া চেকের অর্থপ্রদান বন্ধ করব না বা ক্ষতির রিপোর্ট করব না উল্লিখিত চেক থানায়। আমরা সেই অ্যাকাউন্টটি বন্ধ করব না, যদি আমরা তা করি তবে কোম্পানির আমাদের বিরুদ্ধে আইনি ব্যবস্থা নেওয়ার অধিকার থাকবে।</p>
                        <p>24. এটি কোম্পানির স্টোরেজ সম্পর্কিত সুবিধার সময় যেমন S.M.S. আমরা কলিং, ইমেল বিজ্ঞপ্তি প্রদানের জন্য প্রয়োজনীয় অতিরিক্ত পরিষেবা চার্জ প্রদান করব।</p>
                        <p>25. এই চুক্তি অনুসারে গ্যারান্টার সম্পূর্ণরূপে দায়ী এবং দায়বদ্ধ, যদি কোনও গুরুতর অসুস্থতা দে খা দেয় বা কোনও সদস্য কিস্তি দিতেj অক্ষম হয় বা আবেদনের ভবিষ্যতে কোনও ধরণেরn খেলাপি হয়, তবে সম্পূর্ণ ঋণ গ্যারান্টার এবং গ্রুপ সদস্যদের দ্বারা পরিশোধ করা হবে। শেষ  কিস্তির আগে। </p>
                        <p>26. আমি/আমাদের দ্বারা কোম্পানীকে দেওয়া সমস্ত তথ্য মৌখিকভাবে প্রদান করা হয়েছে যা সত্য এবং সঠিক যাতে কোন প্রকারের কোন মিথ্যা তথ্য বলা হয়নি, যদি কোন তথ্য মিথ্যা বলে প্রমাণিত হয় তবে কোম্পানির অধিকার রয়েছে আমাদের বিরুদ্ধে আইনি ব্যবস্থা নিতে। আমি ঋণ সংক্রান্ত যাবতীয় তথ্য, যেমন সুদের পরিমাণ সংরক্ষণ করব। কিস্তি, কিস্তির সময় এবং পরিশোধের সময়। কোম্পানির কর্মচারীর দ্বারা আমাকে সম্পূর্ণ তথ্য দেওয়া হয়েছে, আমরা উপরের সমস্ত শর্তাবলীর জন্য সম্পূর্ণরূপে প্রস্তুত এবং যদি আমি/আমরা কিস্তি পরিশোধে দেরি করি, তাহলে ভবিষ্যতে আইনগত ব্যয় এবং অন্যান্য খরচের অতিরিক্ত বোঝা চাপা হবে। আমাদের দ্বারা প্রদত্ত।</p>
                        <p>27. আমার/আমাদের দ্বারা জমা দেওয়া সমস্ত নথি যেমন আধার কার্ড, প্যান কার্ড, রেশন কার্ড, ড্রাইভিং লাইসেন্স, ব্যাঙ্কের পাসবুক এবং ছবির সাথে কোনও কারসাজি করা হয়নি বা ভবিষ্যতে আমাদের দ্বারা কোনও জাল নথি জমা দেওয়া হয়েছে, যদি কোনও নথি জাল পাওয়া গেছে, কোম্পানির দ্বারা আমাদের বিরুদ্ধে 420 মামলা করা যেতে পারে, যা আমরা ইতিমধ্যেই অবগত।</p>
                        <p>28. আমি/আমরা উল্লিখিত তারিখের প্রতি 15 দিনে আমাদের কিস্তি পরিশোধ করতে চাই।</p>
                        <p>29. এই ঋণ পরিশোধের জন্য এবং বকেয়া বা এর কোনো অংশ গ্রহণের জন্য বা অন্য কোনো নির্দিষ্ট উদ্দেশ্যে কোম্পানীর দ্বারা ডাকা হলে আমি/আমরা যথাসময়ে উপস্থিত থাকব।</p>
                        <p>30. আমার বার্ষিক আয় 500000/--এর কম, উক্ত চুক্তি বা ঋণ করার সময় আমরা কোন প্রকার নেশা করিনি, আমরা সম্পূর্ণ সচেতনতার সাথে এই চুক্তিটি করছি।</p>
                        <p>31.আবেদনকারী  সহ-আবেদনকারীর বা জামিনদারের স্বাভাবিক বা দুর্ঘটনাজনিত মৃত্যু হলে কোন কিস্তি দিতে হবে না, তবে মৃত্যুর শংসাপত্র জমা দেওয়ার ১৫ দিন পর থেকে।</p>
                        <br><br><br><br><br><br><br><br><br><br>
                        <p>
                          <table class="table" style="border-width:1px;width:100%;font-size:12px;bottom:20px;">
                            <thead>
                              <th>Member Signature <br>((সদস্যের স্বাক্ষর))</th>
                              <th>Guarantor Signature <br>(গ্যারেন্টারের স্বাক্ষর)</th>
                              <th>Branch Seal With Signature <br>(শাখা সিল স্বাক্ষর সহ)</th>
                            </thead>
                          </table>
                        </p>
                        <p style="page-break-before: always;"></p>
                        <p><strong>Loans is subject to the following rules:-</strong></p>
                        <p>1. Loans are granted with interest of other members who hold operative account with company.</p>
                        <p>2. All loans are repayable by monthly /weekly /daily installments depending upon the income / repayment capacity of the borrower but within a maximum period granted by the company.</p>
                        <p>3. An Applicant should be a holder of shares as prescribed by the company from time to time.</p>
                        <p>4. Sureties must also be member of the company with holding active account. Two or more sureties will be required for loans against personal sureties / SHG scheme / Joint liability scheme. A person cannot stand surety for more than one loan at a time. Moreover members already in debt of the company cannot stand surety / Guarantee.</p>
                        <p>5. Loans will only be sanctioned if the company is satisfied about the information furnished by the applicant as well as sureties along with past record of the applicant and sureties.</p>
                        <p>6. The company shall not be bound to give the reason for refusing a loan application or for disapproving the extended surety or sureties.</p>
                        <p>7. Notwithstanding that a loan has been sanctioned by company's loan approving committee I Secretary or General Manager may for reason with hold the advance. The company reserves the right of revoking the sanction at its discretion and shall not be required, or called upon to assign any reason for the same.</p>
                        <p>8. Seven days delay in monthly, one week delay in weekly, one day delay in daily installment will convert the loan into overdue loan and may attract a notice for which Rs. 100/- will be charged from the Loanee for each notice.</p>
                        <p>9. Loan is liable to be recalled immediately if in the opinion of the company, it is not applied for the purpose it was taken. The company's decision in this regard being final and conclusive and not liable to be called in the question by the borrower or the sureties.</p>
                        <p>10. In case of persistent default for two months by any borrower, the company reserves the right of approaching the employers of the borrowers or sureties and / or publishes their names for the information of their members. Moreover it may also approach appropriate authority(s) for recovering the loan in legal manner.</p>
                        <p>11. If for any reason the borrower is unable to repay the agreed installments on the due date he / she should pay as much as possibly can (however small it may be) and should also apply in writing for reduction of installments or extension of time within written consent of his/ her sureties giving there in details of his / her circumstances why he / she is unable to repay the agreed monthly installment, weekly installment, daily installment.</p>
                        <p>12. The company is not bound to give any intimation and non receipt of any intimation or notice cannot be pledged as an excuse by the surety form on payment of installment by the borrower. it is the duty of the surety to see that the borrower pays agreed monthly installment, weekly installment, daily installment on the due date; and incase of default by the borrower or inability or failure of the borrower to pay installment, the surety must pay it before next month's due date thereon forthwith. A member should stand surety to another, only if he recognize and can fulfill his / her duty of a surety. It should be clearly understood that every surety is responsible for the full amount of the loan (including service and other charges if any) and not in proportion.</p>
                        <p>13. The borrower and the sureties shall execute the loan bond and other documentation relating to by presenting themselves personally at the company before one of the officers.</p>
                        <p>14. The company shall levy a service charge on loans decided by the managing committee from time to time for recovering the administrative and running expenses of the company.</p>
                        <p>15. The borrowers and sureties are bound to inform the office within three days in case of any changes in their address or contact numbers.</p>
                        <p>16. All the above parties agree on all the following terms and condition that the borrower will use this amount as per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree that if the company finds any reason to explain which has not been complied with, the company has the right to withdraw this loan amount or part thereof without any Will withdraw the concession.</p>
                        <p>17. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against us in any court nor any FIR is registered in any police station.</p>
                        <p>18. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor have I/we been declared a defaulter from any financial institution, bank or finance company.</p>
                        <p>19. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the payment under any circumstances</p>
                        <p>20. That whichever employee of the company will come to collect the instalment amount, I will keep polite behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is done by us then company will be free to take legal action against us.</p>
                        <p>21. That I/We the company will not be responsible for giving notices, reminders and electronic information phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan, the entire responsibility related to this will be my / ours.</p>
                        <p>22. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email Id, they shall give prior written notice to the company.</p>
                        <p>23. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the right to take legal action against us.</p>
                        <p>24. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service charge required for providing the calling, email notice.</p>
                        <p>25. That the guarantor is fully responsible and liable as per this agreement, if any serious illness occurs Or any members unable to pay installment Or any kind of default with the application future, the entire loan shall be paid by the guarantor & group members within the due date. </p>
                        <p>26. That all the information given by me/us to the company has been provided orally which is the true and correct in which no false fact of any kind have been told , if any information is found to be false then the company has the right to take legal action against us. I will keep all the information about the loan, Such as the amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete information by the company employee, we are fully prepared for all the above terms and condition and if me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which will come in future will be provided by us.</p>
                        <p>27. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license, Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in future, if any document is found to be forged, we can be sued for 420 by the company, which we are already aware of.</p>
                        <p>28. That me/we want to pay our instalments every 15 days of said dated. </p>
                        <p>29. That I/we shall be present in time as and when called for by the company for the payment of this loan and acceptance of the arrears or any part thereof or for any other specified purpose.</p>
                        <p>30. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said agreement or loan, we are doing this agreement in full consciousness.</p>
                        <p>31. No installments have to paid if any normal Or accidental death of Applicant Or Co-applicant/Surety after 15 days of submit his/her death certificate.</p>
                        <br><br><br><br><br><br><br>
                        <p>
                          <table class="table" style="border-width:1px;width:100%;font-size:12px;bottom:20px;">
                            <thead>
                              <th>Member Signature <br>((সদস্যের স্বাক্ষর))</th>
                              <th>Guarantor Signature <br>(গ্যারেন্টারের স্বাক্ষর)</th>
                              <th>Branch Seal With Signature <br>(শাখা সিল স্বাক্ষর সহ)</th>
                            </thead>
                          </table>
                        </p>
                      </div>
                      <div v-else>
                        <p style="page-break-before: always;"></p>
                        <p><strong>नियम और शर्ते</strong></p>
                        <p>1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे</p>
                        <p>2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।</p>
                        <p>3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।</p>
                        <p>4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।</p>
                        <p>5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे</p>
                        
                        <p>6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी</p>
                        <p>7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे</p>
                        <p>8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !</p>
                        <p>9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|</p>
                        <p>10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा</p>
                        <p>11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | </p>
                        <p>12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | </p>
                        <p>13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | </p>
                        <p>14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | </p>
                        <p>15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | </p>
                        <br><br><br><br><br><br><br><br><br><br>
                        <p><table class="table" style="border-width:1px;width:100%;font-size:12px;bottom:20px;">
                            <thead>
                              <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                              <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                              <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                            </thead>
                          </table>
                        </p>
                        <p style="page-break-before: always;"></p>
                      <p><strong>Terms and Condition</strong></p>
                      <p>1. All the above parties agree on all the following terms and condition that the borrower will use this amount as
                        per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree
                        that if the company finds any reason to explain which has not been complied with, the company has the right to
                        withdraw this loan amount or part thereof without any Will withdraw the concession.</p>
                      <p>2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against
                        us in any court nor any FIR is registered in any police station.</p>
                      <p>3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor
                        have I/we been declared a defaulter from any financial institution, bank or finance company.</p>
                      <p>4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the
                        payment under any circumstances</p>
                      <p>5. That whichever employee of the company will come to collect the instalment amount, I will keep polite
                        behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any
                        way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is
                        done by us then company will be free to take legal action against us.</p>
                      <p>6. That I/We the company will not be responsible for giving notices, reminders and electronic information
                        phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,
                        the entire responsibility related to this will be my / ours.</p>
                      <p>7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email
                        Id, they shall give prior written notice to the company.</p>
                      <p>8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by
                        us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the
                        loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the
                        right to take legal action against us.</p>
                      <p>9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service
                        charge required for providing the calling, email notice.</p>
                      <p>10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or
                        insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.</p>
                      <p>11. That all the information given by me/us to the company has been provided orally which is the true and
                        correct in which no false fact of any kind have been told , if any information is found to be false then the
                        company has the right to take legal action against us. I will keep all the information about the loan, Such as the
                        amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete
                        information by the company employee, we are fully prepared for all the above terms and condition and if
                        me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which
                        will come in future will be provided by us.</p>
                      <p>12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,
                        Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in
                        future, if any document is found to be forged, we can be sued for 420 by the company, which we are already
                        aware of.</p>
                      <p>13. That me/we want to pay our instalments monthly.</p>
                      <p>14. That I/we shall be present in time as and when called for by the company for the payment of this loan and
                        acceptance of the arrears or any part thereof or for any other specified purpose. </p>
                      <p>15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said
                        agreement or loan, we are doing this agreement in full consciousness.</p>
                      <br><br><br><br><br><br><br>
                      <p><table class="table" style="width:100%">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      </div>
                      <br><br><br><br><br>

                      </div>
                      <div v-if="seeRecord.status == 'pending'">
                        <br><br>
                        <table class="table" style="border-width:1px; width:100%;">
                          <thead>
                            <th>Application Date</th>
                            <th>Customer</th>
                            <th>Account Number</th>
                            <th>Guarantor Name</th>
                            <th>Loan Amount</th>
                            <th>Paid Amount</th>
                            <th v-show="pl.planType === 'normal'">No. of EMI</th>
                          </thead>
                          <tbody>
                            <td>{{seeRecord.disbursementDate | myDate}}</td>
                            <td><i v-if="seeRecord.member">{{seeRecord.member.name}} ({{seeRecord.member.code}})</i></td>
                            <td>{{mem.accountNumber}}</td>
                            <td>{{mem.guarantorName}}</td>
                            <td v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ pl.amount + pl.fileCharge + pl.processingFee }}</td>
                            <td v-else>{{ pl.amount + (pl.fileCharge) + (pl.amount * pl.processingFee)/100 }}</td>
                            <td>{{pl.amount}}</td>
                            <td v-show="pl.planType === 'normal'">{{pl.noOfPayments}}</td>
                          </tbody>
                        </table>
                        <br><br>
                        <table class="table" v-if="seeRecord.status == 'pending'" style="border-width:1px; width:100%;">
                          <thead>
                            <th>Branch Manager Signature</th>
                            <th>Customer Signature</th>
                            <th>Date</th>
                          </thead>
                        </table>
                        <br><br>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintCustomerEMIModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printCustomerEMI()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            
            <div class="modal-body" id="printCustomerEMI">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed" width="100%">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-center" style="text-align:center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" style="text-align:center" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h3 class="text-center" style="text-align:center;">Loan EMI Card</h3>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed" style="border-width:1px; width:100%;">
                        <thead>
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Customer Name </td><td> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td>Group Name </td><td> {{seeRecord.collection_center.name}}</td>
                          </tr>
                          <tr>
                            <td>Contact No </td><td> {{seeRecord.member.mobile}}</td>
                            <td>Spouse Name </td><td> {{mem.spouseName}}</td>
                          </tr>
                          <tr>
                            <td><strong>Loan Amount</strong></td>
                            <td>₹ {{planAmt(seeRecord) }}</td>
                            <td>Plan Name </td><td> {{pl.name}} </td>
                          </tr>
                          <tr>
                            <td><strong>Number of EMI </strong></td><td> {{ pl.noOfPayments }}</td>
                            <!-- <td><strong>File Charge : </strong></td><td>{{ fileChargeFee(seeRecord) }}</td> -->
                            <td><strong>EMI Amount - </strong></td><td> ₹ {{memberFirstEmiRecord}}</td>
                            <!-- <td>Total Paid Amount </td><td> {{memberTotalDueAmt}} </td> -->
                          </tr>
                          
                        </tbody>
                      </table>
                      
                      <h3 class="text-center" style="text-align:center;">EMI Schedule Terms </h3>
                      
                      <table class="table table-condensed" style="border-width:1px; width:100%;">
                        <thead>
                          <tr>
                            <td><strong>Sr. No</strong></td>
                            <td><strong>Loan EMI Date</strong></td>
                            <!-- <td><strong>Interest</strong></td>
                            <td><strong>Principal</strong></td> -->
                            <td><strong>Amount</strong></td>
                            <!-- <td><strong>Remaining Amt</strong></td> -->
                            <td><strong>Receiving Date</strong></td>
                            <td><strong>Received Amt</strong></td>
                            <td><strong>Staff Sign</strong></td>
                            <!-- <td><strong>Senior Sign</strong></td> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(memberEmiRecord) in memberEmiRecords" :key="memberEmiRecord.id">
                            <td>{{memberEmiRecord.emiNo}}</td>
                            <td>{{memberEmiRecord.emiDate | myDate}}</td>
                            <!-- <td>{{memberEmiRecord.intrest}}</td>
                            <td>{{memberEmiRecord.principal}}</td> -->
                            <td>{{memberEmiRecord.total}}</td>
                            <!-- <td>{{memberEmiRecord.memberDueAmt}}</td> -->
                            <td></td>
                            <td></td>
                            <td></td>
                            <!-- <td></td> -->
                          </tr>
                        </tbody>
                      </table>
                      <br>   
                      <br><br>
                      <p>
                        <table class="table" style="border-width:1px; width:100%;">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      

                      </div>
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintCustomerModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printCustomer()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printCustomer">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed" width="100%">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td colspan="2" class="text-center" style="text-align:center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" style="text-align:center" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h2 class="text-center" style="text-align:center">Loan Sanction Letter</h2>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed" width="100%">
                        <thead>
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Disbursment Date : {{seeRecord.disbursementDate | myDate}}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Customer Name </td><td> {{seeRecord.member.name}}  ({{seeRecord.member.code}})</td>
                            <td>Group Name : {{seeRecord.collection_center.name}}</td>
                            <td rowspan="3">
                              <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br>Customer <br> & <br>Guarantor Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr>
                            <td>Contact No </td><td> {{seeRecord.member.mobile}}</td>
                            <td>Gender : {{mem.gender}}</td>
                          </tr>
                          <tr>
                            <td>Adhar Number </td><td> {{mem.aadharNo}}</td>
                            <td>Spouse Name  : {{mem.spouseName}}</td>
                          </tr>
                          <tr v-if="mem.fatherName">
                            <td>Father Name (C/O)  </td><td> {{mem.fatherName}}</td>
                            <td colspan="2"></td>
                          </tr>
                          
                          <tr>
                            <td colspan="4"><strong>Address Details</strong></td>
                          </tr>
                          <tr>
                              <td><strong>Address </strong></td><td> {{mem.address}}, {{mem.area}}</td>
                              <td><strong>District/State/Pincode </strong></td><td v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                            </tr>
                            <tr>
                              <td colspan="2"><strong>Bank Details :</strong></td>
                              <td colspan="2"><strong>Applied Loan Details</strong></td>
                            </tr>
                            <tr>
                              <td><strong>Bank : </strong> <span v-if="mem.bank"> {{mem.bank.name}}</span> </td>
                              <td><strong>Branch : </strong><span v-if="mem.bankBranch"> {{mem.bankBranch}}</span></td>
                              <td><strong>Loan ID :</strong> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span> </td>
                              <td><strong>Plan Name :</strong> {{pl.name}}</td>
                            </tr>
                            <tr>
                              <td><strong>Account Holder : </strong>{{mem.accountHolderName}}</td>
                              <td><strong>IFSC : </strong> <span v-if="mem.ifsc">{{mem.ifsc}}</span></td>
                              <td><strong v-if="pl.rateOfInterest > 0">Interest Rate (%) : {{pl.rateOfInterest}} </strong></td>
                              <!-- <td><strong>Interest Rate (%) :</strong> 22.7 </td> -->
                              <td> <strong>GST Include : </strong>{{pl.includeGst}}</td>
                              <!-- <td>Insurance Charge </td><td v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td v-else> {{pl.fileCharge}}</td> -->
                            </tr>
                            <tr>
                              <td><strong>Account Number : </strong></td>
                              <td>{{mem.accountNumber}}</td>
                              <td><strong>Loan Amount :</strong> {{ planAmt(seeRecord) }}</td>
                              <td><strong>File Charge : </strong>{{ fileChargeFee(seeRecord) }}</td>
                            </tr>
                            <tr>
                              <td colspan="2"><strong>Income Details</strong></td>
                              <td><strong>Processing Fee :</strong> {{ processingFee(seeRecord) }}</td>
                              <td><strong>Insurance Fee :</strong> {{ insuranceFee(seeRecord) }}</td>
                            </tr>
                            <tr v-if="pl.rateOfInterest">
                              <td><strong>Income (INR) : </strong>{{mem.incomeAmount}}</td>
                              <td><strong>Occupation : </strong>{{mem.jobType}}</td>
                              <td><strong>Recovery type :</strong> {{pl.recoveryType}}</td>
                              <td><strong>Amount to be Paid :</strong> <span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                              
                            </tr>
                            <tr>
                              <td><strong>Business Name : </strong>{{mem.businessName}}</td>
                              <td><strong>Income Type : </strong>{{mem.incomeType}}</td>
                              <td><strong>No of Payments : </strong> <span v-if="pl.noOfPayments">{{pl.noOfPayments}}</span></td>
                              <td> </td>
                            </tr>
                            <tr>
                              <td><strong>Minimum Income : </strong>{{mem.minAmount}}</td>
                              <td> </td>
                              <td><strong>Purpose : </strong><span v-if="seeRecord.purpose">{{seeRecord.purpose.purpose}}</span></td>
                              <td><strong>Description : </strong>{{seeRecord.description}}</td>
                            </tr>
                            <tr>
                              <td colspan="3"><strong>Guarantor Details : </strong></td>
                              <td rowspan="3">
                                <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Name : </strong> </td><td><span v-if="seeRecord.guarantor"> {{seeRecord.guarantor.name}} ( {{seeRecord.guarantor.code}} )</span></td>
                              <td><strong>Contact Number : </strong><span v-if="seeRecord.guarantor">{{seeRecord.guarantor.mobile}} </span></td>
                            </tr>
                            <tr>
                              <td><strong>Nominee Name : {{mem.nomineeName}}</strong></td>
                              <td><strong>Nominee Mobile : </strong>{{mem.nomineePhone}}</td>
                              <td><strong>Nominee Dob : </strong>{{mem.nomineeDob}}</td>
                            </tr>
                          
                        </tbody>
                      </table>
                      </div><br><br><br><br><br>
                      <p><table class="table" style="border-width:1px; width:95%; position:absolute; bottom:25px;">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Loan Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr>
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                              </td>
                              <td>
                                <!-- <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }} -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td v-if="pl.created_by">
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_id">
                          <b>Member Name</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b>
                          <a class="pull-right">{{ seeRecord.paymentMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <!-- Demand Probeshnary note  -->
      <printviewdisbursementcollectioncenterwise :seeRecords="this.seeRecords" :branch="branch" :collectionCenter="collectionCenter" :getCompanyRecord="getCompanyRecord" :logo="logo"></printviewdisbursementcollectioncenterwise>
      <!-- /.modal -->
      <!-- Demand Probeshnary note  -->
      <demandprobeshnarynote :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></demandprobeshnarynote>
      <!-- /.modal -->
      <!-- Aadhar Loan Agreement  -->
      <aadharagreementletter :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></aadharagreementletter>
      <!-- /.modal -->
      <!-- Previous Loan Record  -->
      <previousloanrecord :seeRecord="seeRecordPrevious" :getCompanyRecord="getCompanyRecord" :memberloanplans="memberloanplans" :logo="logo"></previousloanrecord>
      <!-- /.modal -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
import { Printd } from 'printd'
import BranchWiseCollectionCenter from '../../mixins/BranchWiseCollectionCenterData'
import DisbursementByCollectionCenter from '../../mixins/DisbursementByCollectionCenter'
import getPreviousLoan from '../../mixins/PreviousLoanRecord'
import VueBarcode from 'vue-barcode'
import printviewdisbursementcollectioncenterwise from '../components/PrintViewDisbursementCollectionCenterWise.vue'
import demandprobeshnarynote from '../components/DemandProbeshnaryNote.vue'
import aadharagreementletter from '../components/AdharAgreementLetter.vue'
import previousloanrecord from '../components/PreviousLoanRecord.vue'
export default {
  name: 'my-component',
  mixins: [BranchWiseCollectionCenter, DisbursementByCollectionCenter, getPreviousLoan],
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      @page {
        size: A4;
        margin: 0;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      p {font-size:12px;}
      table, th, td { border:1px solid #000;font-size:12px; padding:0.4em; border-collapse: collapse; }`,
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      seeRecordPrevious: {},
      branch: {},
      per_page: 10,
      table_search: '',
      totalAmt: 0,
      editMode: false,
      logo: '',
      adhar: '',
      mem: {},
      memberTotalDueAmt: null,
      collectionCenters: [],
      collectionCenter: {},
      branches: [],
      members: [],
      memberEmiRecords: [],
      memberFirstEmiRecord: null,
      staffs: {},
      bank_accounts: [],
      pl: {},
      seeRecord: {},
      seeRecords: [],
      loanplans: [],
      processingFeeType: '',
      insuranceFeeType: '',
      groupMembers: {},
      getCompanyRecord: {},
      viewCollectionCenter: '',
      memberloanplans: [],
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        plan: {},
        planType: 'individual',
        status: '',
        branch_ledger_id: '',
        disbursement_id: '',
        disbursementStartDate: '',
        disbursementEndDate: '',
        startEmiEndDate: '',
        endEmiEndDate: '',
        emiStartDate: '',
        processingFee: null,
        insuranceFee: null,
        fileCharge: null,
        amt: '',
        type: '',
        paymentDate: null
      }),
      // columns: [
      //   {
      //     label: 'PLAN Name',
      //     field: 'plan_name'
      //   },
      //   {
      //     label: 'Amount',
      //     field: 'plan_amt'
      //   },
      //   {
      //     label: 'Dis. Date',
      //     field: 'DisbursementDate'
      //   },
      //   {
      //     label: 'Start Date',
      //     field: 'EmiStartDate'
      //   },
      //   {
      //     label: 'End Date',
      //     field: 'EmiEndDate'
      //   },
      //   {
      //     label: 'Group Name',
      //     field: 'collection_center.name'
      //   },
      //   {
      //     label: 'MEMBER',
      //     field: 'member.name'
      //   },
      //   {
      //     label: 'AGENT',
      //     field: 'agent.name'
      //   },
      //   {
      //     label: 'MODE',
      //     field: 'branch_ledger.ledger.name'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  components: {
    'barcode': VueBarcode,
    demandprobeshnarynote,
    printviewdisbursementcollectioncenterwise,
    aadharagreementletter,
    previousloanrecord
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewPreviousLoanRecords (row) {
      this.seeRecordPrevious = row
      this.loadCompanyProfile()
      this.getPreviousLoanRecord(row.member_id)
      $('#viewPreviousLoanRecord').modal({backdrop: 'static', keyboard: false})
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    planRecoveryType (plan) {
      var pln = JSON.parse(plan)
      return pln.recoveryType
    },
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    getRecordByCollectionCenter (collectionCenter) {
      this.form.collection_center_id = ''
      if (collectionCenter) {
        this.form.collection_center_id = collectionCenter.id
        this.form.branch_id = collectionCenter.branch_id
      }
      this.changeFilter()
    },
    fileChargeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#fileChargeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'fileCharge'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.includeGst === 'true') {
        this.form.amt = row.fileCharge ? row.fileCharge + (row.fileCharge * 18 / 100) : this.pl.fileCharge + (this.pl.fileCharge * 18 / 100)
      } else {
        this.form.amt = row.fileCharge ? row.fileCharge : this.pl.fileCharge
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    processingFeeModal (row) {
      var pfamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#processingFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'processingFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (this.pl.processingFee * row.loanAmount / 100) : (this.pl.processingFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      if (this.pl.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : this.pl.processingFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    insuranceFeeModal (row) {
      var ifamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#insuranceFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'insuranceFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (this.pl.insuranceFee * row.loanAmount / 100) : (this.pl.insuranceFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      if (this.pl.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : this.pl.insuranceFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    // file charge and processing fee collection
    fileChargeProcessingFeeCollect () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.disbursementStartDate = ''
          this.form.disbursementEndDate = ''
          this.form.startEmiEndDate = ''
          this.form.endEmiEndDate = ''
          this.form.branch_id = ''
          this.changeFilter()
          if (this.form.type === 'fileCharge') {
            $('#fileChargeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'File Charge Paid Successfully'
            })
          }
          if (this.form.type === 'processingFee') {
            $('#processingFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Processing Fee Paid Successfully'
            })
          }
          if (this.form.type === 'insuranceFee') {
            Fire.$emit('AfterCreate')
            $('#insuranceFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Insurance Fee Paid Successfully'
            })
          }
          Fire.$emit('AfterCreate')
        })
    },
    fileChargeFee (row) {
      var fcamt
      var pln = JSON.parse(row.plan)
      fcamt = row.fileCharge ? row.fileCharge : pln.fileCharge
      if (pln.includeGst === 'true') {
        return fcamt + fcamt * 18 / 100
      } else {
        return fcamt
      }
    },
    processingFee (row) {
      var pfamt
      var pln = JSON.parse(row.plan)
      if (pln.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (pln.processingFee * row.loanAmount / 100) : (pln.processingFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
      if (pln.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : pln.processingFee
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
    },
    insuranceFee (row) {
      var ifamt
      var pln = JSON.parse(row.plan)
      if (pln.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (pln.insuranceFee * row.loanAmount / 100) : (pln.insuranceFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
      if (pln.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : pln.insuranceFee
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
    },
    viewPrintModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintModal').modal({backdrop: 'static', keyboard: false})
      this.$axios
        .get('memberemi?all=all&disbursement_id=' + row.id + '&member_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('get member emi records')
          // console.log(data.data)
          this.memberEmiRecords = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
      )
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintCustomerEMIModal (row) {
      this.memberTotalDueAmt = 0
      var mTotalDueAmt = 0
      var fpi = 0
      var gstAmt = 0
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType !== 'normal') {
        if (this.pl.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(this.pl.fileCharge)
        }
        if (this.pl.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(this.pl.processingFee)
        }
        if (this.pl.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(this.pl.insuranceFee)
        }
        if (this.pl.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        mTotalDueAmt = row.loanAmount ? row.loanAmount + fpi : this.pl.amount + fpi
      } else {
        mTotalDueAmt = row.loanAmount ? row.loanAmount : this.pl.amount
      }
      this.$axios
        .get('memberloanplan?disbursement_id=' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberTotalDueAmt = data.data.data[0].totalAmt
          this.$axios
          .get('memberemi?all=all&disbursement_id=' + row.id + '&member_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.memberEmiRecords = data.data
            this.memberFirstEmiRecord = data.data[0].total
            $.each(this.memberEmiRecords, function (key, value) {
              this.memberEmiRecords[key].memberDueAmt = mTotalDueAmt - this.memberEmiRecords[key].principal
              mTotalDueAmt = mTotalDueAmt - this.memberEmiRecords[key].principal
            }.bind(this))
          }).catch(function (error) { console.log(error) })
        }).catch(function (error) { console.log(error) })
      this.form.reset()
      this.loadCompanyProfile()
      this.seeRecord = row
      $('#viewPrintCustomerEMIModal').modal({backdrop: 'static', keyboard: false})
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    showPlanAmtNormal (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount + this.seeRecord.fileCharge + this.seeRecord.processingFee
      } else {
        return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      }
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    viewPrintCustomerModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintCustomerModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
          this.adhar = (this.mem.aadharNo !== null) ? this.mem.aadharNo.replace(/\d(?=\d{4})/g, '*') : ''
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: error })
            // this.form.errors.errors = error.response.data.error
          }
        )
    },
    viewPrintDimandProbeshnoryNote (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintDimandProbeshnoryNote').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteDisbursment (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('disbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewPrintAadharAgreementLetter (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintAadharAgreementLetter').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getBranchMember () {
      this.form.member_id = this.mem.user_id
    },
    getBranchCollectionCenter () {
      this.form.collection_center_id = this.colC.id
      this.loadGroupMember(this.form.collection_center_id)
    },
    getBranchBankAccount (id) {
      this.$axios
        .get('branchledger?all=all&status=active&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')

              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getPlanType () {
      this.form.center_leader_id = null
      this.form.collection_center_id = null
      this.form.member_id = null
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadLoan () {
      this.$axios
        .get('loanplan?all=all&status=true', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    print () {
      const d = new Printd()
      d.print(document.getElementById('print'), [this.cssText])
      // Get HTML to print from element
      // const prtHtml = document.getElementById('print').innerHTML
      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:1px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    },
    printCustomer () {
      const d = new Printd()
      d.print(document.getElementById('printCustomer'), [this.cssText])
      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      // Get HTML to print from element
      // const prtHtml = document.getElementById('printCustomer').innerHTML

      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:1px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    },
    printCustomerEMI () {
      const d = new Printd()
      d.print(document.getElementById('printCustomerEMI'), [this.cssText])
      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      // Get HTML to print from element
      // const prtHtml = document.getElementById('printCustomerEMI').innerHTML

      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:1px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    },
    changeFilter (page = null, pg = null) {
      // var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'disbursement'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      // if (c.type !== 'admin') {
      //   pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      //   if (c.role.name === 'Manager' || c.role.name === 'Accountant') {
      //   } else {
      //     pageUrl += `&agent_id=${c.id}`
      //   }
      // }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      if (this.form.disbursementStartDate) {
        pageUrl += `&disbursementStartDate=${this.form.disbursementStartDate}`
      }
      if (this.form.disbursementEndDate) {
        pageUrl += `&disbursementEndDate=${this.form.disbursementEndDate}`
      }
      if (this.form.startEmiEndDate) {
        pageUrl += `&startEmiEndDate=${this.form.startEmiEndDate}`
      }
      if (this.form.endEmiEndDate) {
        pageUrl += `&endEmiEndDate=${this.form.endEmiEndDate}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      this.$axios
        .get(`${pageUrl}&status=disbursed&searchTerm=group`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.totalAmt = 0
    //   this.$axios
    //     .get('disbursement?all=all&status=disbursed&searchTerm=group&disbursementStartDate=' + this.form.disbursementStartDate + '&disbursementEndDate=' + this.form.disbursementEndDate + '&startEmiEndDate=' + this.form.startEmiEndDate + '&endEmiEndDate=' + this.form.endEmiEndDate + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //       _.forEach(this.rows, function (row, key) {
    //         if (row.loanAmount > 0) {
    //           this.totalAmt += row.loanAmount
    //         } else {
    //           this.totalAmt += parseInt(JSON.parse(row.plan).amount)
    //         }
    //       }.bind(this))
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  },

  created () {
    // this.loadMember()

    this.changeFilter()
    this.loadBranch()
    this.loadLoan()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  @media print {
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  .content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// GroupMemberDisbursment.vue?4d559da0